import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@routes';

import { projects } from '@config/projects';

import { ProjectId } from '@types';

import { projectsHandleSelect } from '@actions/projects/projects-handle-select';
import { projectsGetCurrentProject } from '@selectors/projects';

import { useTypedDispatch, useTypedSelector } from '@hooks/store';

import { Dropdown, DropdownOptions } from '@kit/dropdown';

import { ProjectSelectorDropdownHandleChange } from './types';

export const ProjectSelectorDropdown: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useTypedDispatch();
  const selectedProject = useTypedSelector(projectsGetCurrentProject);
  const [selectedProjectName, setSelectedProjectName] = useState(
    selectedProject?.id
  );

  const options: DropdownOptions = useMemo(
    () =>
      projects.map((project) => ({
        value: project.id,
        label: project.id,
        color: 'text.primary',
        iconSrc: project.iconSrc,
      })), //
    []
  );

  const handleChange: ProjectSelectorDropdownHandleChange = useCallback(
    (event) => {
      dispatch(
        projectsHandleSelect({
          projectId: event.target.value as ProjectId,
        })
      );
    },
    [dispatch]
  );

  useEffect(() => {
    if (selectedProject?.id !== selectedProjectName) {
      setSelectedProjectName(selectedProject?.id);
      navigate(ROUTES.dashboard);

      /////TODO: temporary solution
      window.location.reload();
    }
  }, [navigate, selectedProject, selectedProjectName]);

  if (!options.length) {
    return null;
  }

  return (
    <Dropdown
      fullWidth //
      options={options}
      value={selectedProject?.id ?? options[0].value}
      onChange={handleChange}
    />
  );
};
